import React from 'react';
import { IProject } from '../interface/IProject';
import CustomTable, { IColumn } from './CustomTable';
import { Box, Dropdown, IconButton, MenuButton, Typography, Menu, MenuItem, Divider } from '@mui/joy';
import MoreHorizRoundedIcon from '@mui/icons-material/MoreHorizRounded';
import dayjs from 'dayjs';

function RowMenu({ onEdit, onDelete }: any) {
  return (
    <Dropdown>
      <MenuButton slots={{ root: IconButton }} slotProps={{ root: { variant: 'plain', color: 'neutral', size: 'sm' } }}>
        <MoreHorizRoundedIcon />
      </MenuButton>
      <Menu size='sm' sx={{ minWidth: 140 }}>
        <MenuItem onClick={onEdit}>Edit</MenuItem>
        <Divider />
        <MenuItem color='danger' onClick={onDelete}>
          Delete
        </MenuItem>
      </Menu>
    </Dropdown>
  );
}

type Props = { projects: IProject[]; onEdit: (project: IProject) => void; onDelete: (projectId: number) => void };

const ProjectTable = ({ projects, onEdit, onDelete }: Props) => {
  const columns: IColumn<IProject>[] = [
    {
      id: 'id',
      disablePadding: false,
      label: 'ID',
      numeric: false,
      dataIndex: 'projectId',
      width: 50,
    },
    {
      id: 'project_name',
      disablePadding: false,
      label: 'Project Name',
      numeric: false,
      dataIndex: 'name',
      width: 120,
      sort: true,
    },
    {
      id: 'created',
      disablePadding: false,
      label: 'Created',
      numeric: false,
      dataIndex: 'createdAt',
      render: (row) => (
        <>
          <Typography level='body-xs'>{row.createdAt ? dayjs(row.createdAt).format('DD.MM.YYYY - HH:mm') : ''}</Typography>
          <Typography level='body-xs'>{row.createdBy || ''}</Typography>
        </>
      ),
      width: 160,
    },
    {
      id: 'updated',
      disablePadding: false,
      label: 'Updated',
      numeric: false,
      dataIndex: 'updatedAt',
      render: (row) => (
        <>
          <Typography level='body-xs'>{row.updatedBy ? dayjs(row.updatedAt).format('DD.MM.YYYY - HH:mm') : ''}</Typography>
          <Typography level='body-xs'>{row.updatedBy || ''}</Typography>
        </>
      ),
      width: 160,
    },
    {
      id: 'actions',
      disablePadding: false,
      label: '',
      numeric: false,
      dataIndex: 'projectId',
      render: (row) => (
        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
          <RowMenu onEdit={() => onEdit(row)} onDelete={() => onDelete(row.projectId)} />
        </Box>
      ),
      width: 50,
    },
  ];

  return (
    <React.Fragment>
      <CustomTable data={projects} idKey='projectId' columns={columns} />
    </React.Fragment>
  );
};

export default ProjectTable;
